// extracted by mini-css-extract-plugin
module.exports = {"amount":"BalanceDue_amount__1jhlW","list":"BalanceDue_list__22AnZ","listRow":"BalanceDue_listRow__2pkkZ","total":"BalanceDue_total__4vgIW"};